<template>
  <div class="modal" @click="closeModal" ref="modal">
    <div class="modal-content" @click.stop>
      <div class="variations-modal-header">
        <h3>{{variations.length}} Διαθέσιμες Παραλλαγές </h3>
        <span class="close" @click="closeModal">&times;</span>
      </div>
      <div class="modal-subtitle">
        {{ variationGroup.variationGroupName + ' : ' + defaultValue }}
      </div>
      <div class="modal-body">
        <div v-for="variationEntry in variations"
             :key="variationEntry.variationId"
             class="variation-image"
             :class="getVariationImageStatus(defaultValue, variationEntry)"
             @mouseover="displayVariationName = variationEntry.variationName"
             @mouseleave="displayVariationName = ''"
        >
          <img
            :src="`/files/products/${getVariationProductsImage(variationEntry.variationId)}`"
            :alt="variationEntry.variationName"
            @click="navigateToProduct(variationEntry.variationId)"
            class="img-fluid"
            width="100"
            height="100"
          >
          <div class="variation-tooltip" v-if="displayVariationName === variationEntry.variationName">
            {{ variationEntry.variationName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import variationSelectorMixin from './VariationSelectorMixin';

export default {
  name: 'VariationModal',
  props: {
    variationGroup: {
      type: Object,
      required: true
    },
    variations: {
      type: Array,
      required: true
    },
    defaultValue: {
      type: String,
      required: true
    }
  },
  setup (props, { emit }) {
    const modalRef = ref(null)
    const displayVariationName = ref('')

    const closeModal = () => {
      emit('close-modal')
    }

    const getVariationImageStatus = (defaultValue, variation) => {
      const statusMap = [
        { condition: variation.alreadyExists === false, value: 'variation-image-disabled' },
        { condition: getVariationOutOfStock(variation), value: 'variation-image-out_of_stock' },
        { condition: defaultValue === variation.variationName, value: 'variation-image-current_product' }
      ]

      const match = statusMap.find(entry => entry.condition)
      return match ? match.value : ''
    }

    const getVariationOutOfStock = (variation) => {
      return variation.stock <= 0
    }

    return {
      modalRef,
      closeModal,
      displayVariationName,
      getVariationImageStatus
    }
  },
  mixins: [variationSelectorMixin]
}
</script>

<style scoped>

.variation-tooltip {
  width: clamp(100%, 9vw, 150%);
  position: absolute;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  bottom: 120%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
}

.modal {
  display: block;
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
}

.modal-content {
  background-color: #fefefe;
  margin: 28vh auto;
  padding: 20px;
  border: 1px solid #888;
  border-radius: 5px;
  width: 80%;
  max-width: 600px;
  @media screen and (max-width:1000px){
    margin: 40% auto;
  }
}

.variations-modal-header {
  padding: 1.25rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
}

.close {
  cursor: pointer;
  color: #aaa;
  font-size: 28px;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.modal-body {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 15px;
  padding: 20px 0;
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #ffc800 #f7f7f7;
  border-radius:10px;
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ffc800;
    border-radius: 21px;

  }
  @media screen and (max-width:575px){
    grid-template-columns: repeat(2, 1fr);
  }
}

.variation-image {
  display: grid;
  align-items: center;
  justify-items: center;
  &:hover {
    cursor: pointer;
  }
}

.modal-subtitle {
  font-weight: 600;
  font-size: clamp(13px, 2.5vw, 1rem);
  padding: 20px 0 0 0;
}
</style>
